module.exports = __webpack_public_path__ + "static/7cce90a1-bf43-4fff-8466-7711eccca713-3249fa6c1a121fe97fc4f19c1cfc0d1d.webp";